module.exports = __webpack_public_path__ + "media/poll.c3a4affa.webm";